import type { MentionAgent } from '../../services/mention-agents/types.ts';

export const filterAgentsClientSide = (
	agents: readonly MentionAgent[],
	query: string,
	limit?: number,
): readonly MentionAgent[] => {
	const q = query.trim().toLowerCase();
	if (!q) {
		return agents;
	}

	const result = agents.filter((a) => a.name.toLowerCase().includes(q));
	return typeof limit === 'number' ? result.slice(0, limit) : result;
};
